/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Softphoneurl1Inputs */

const en_entity_softphoneurl1 = /** @type {(inputs: Entity_Softphoneurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone URL`)
};

const de_entity_softphoneurl1 = /** @type {(inputs: Entity_Softphoneurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Softphone-URL`)
};

/**
* | output |
* | --- |
* | "Softphone URL" |
*
* @param {Entity_Softphoneurl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_softphoneurl1 = /** @type {((inputs?: Entity_Softphoneurl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Softphoneurl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_softphoneurl1(inputs)
	return de_entity_softphoneurl1(inputs)
});
export { entity_softphoneurl1 as "entity_softphoneUrl" }